import { ListMenuItem } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import {
  StudentEnrollmentBulkUpdatePageState,
  studentEnrollmentBulkUpdatePageRoute,
} from "../StudentEnrollmentBulkUpdatePage/StudentEnrollmentBulkUpdatePage";

export const useStudentEnollmentListMenuItems = (props: { permission: Permission }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(studentEnrollmentBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentEnrollmentBulkUpdatePageState,
        }),
    });

  return menuItems;
};
